import React, { useState } from "react";
import "./FullPagePopup.scss";

const FullPagePopup = ({ children, maxContentWidth }) => {
  const [closed, setclosed] = useState(false);

  const close = () => {
    setclosed(true);
  };

  if (closed) {
    return <></>;
  }

  const childrenWithProps = React.Children.map(children, (child) => {
    // Checking isValidElement is the safe way and avoids a
    // typescript error too.
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { close });
    }
    return child;
  });

  return (
    <div className="full-page-popup">
      <div
        style={{ maxWidth: maxContentWidth || "100%" }}
        className="full-page-popup__container"
      >
        {/* TODO export this into its own component */}
        <button className="btn-close" onClick={close}>
          <div className="btn-close--icon" />
        </button>
        {childrenWithProps}
      </div>
    </div>
  );
};

export default FullPagePopup;
